import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { StringUtil } from 'ml-portals-util-js';

import styles from '../MLClaimDetailPopup/MLClaimDetailPopup.module.scss';

import metadata from './MLPeopleInvolvedComponent.metadata.json5';
import messages from './MLPeopleInvolvedComponent.messages';

const MLPeopleInvolvedComponent = (props) => {
    const {
        mainDriverIncident,
        otherDriversIncidents,
        claimant, 
        formatPhoneNumber
    } = props;

    const translator = useTranslator();
    const showSection = () => {
        return (!_.isUndefined(mainDriverIncident) && !_.isUndefined(mainDriverIncident.driver)) ||
            (otherDriversIncidents && otherDriversIncidents.find((incident) => incident.driver)) ||
            !_.isUndefined(claimant);
    };

    const formatAddressLine1 = (person) => {
        if (!_.isUndefined(person)) {
            return person.primaryAddress.addressLine1;
        }
    };

    const formatAddressLine2 = (person) => {
        if (!_.isUndefined(person)) {
            const city = (person.primaryAddress.city) ? person.primaryAddress.city.concat(',') : '';
            const state = person.primaryAddress.state;
            const postalCode = person.primaryAddress.postalCode;
            const result = [city, state, postalCode].join(' ');
            return result;
        }
    };

    const formatName = (driver) => {
        if (!_.isUndefined(driver)) {
            let firstName = (driver.firstName) ? driver.firstName.toLowerCase() : '';
            let lastName = driver.lastName.toLowerCase();
            firstName = StringUtil.capitalizeFirstLetter(firstName);
            lastName = StringUtil.capitalizeFirstLetter(lastName);
            return firstName.concat(' ', lastName);
        }
    };
    const getOtherVehiclePassengersOverrides = (incident) => {

        const passengers = incident.passengers.map((passenger, index) => {
            return {
                [`otherPassengerName${index}`]: {
                    content: (
                        <b>
                            {formatName(passenger)}
                        </b>
                    )
                }
            }
        });

        return Object.assign({}, ...passengers);
    }

    const getOtherPeopleOverrides = () => {

        if(mainDriverIncident === undefined){
            return {};
        }

        const passengers = mainDriverIncident.passengers.map((passenger, index) => {
            return {
                [`passengerName${index}`]: {
                    content: (
                        <b>
                            {formatName(passenger)}
                        </b>
                    )
                }
            }
        });
        
        const otherDriverIncidents = _.isUndefined(otherDriversIncidents) ? [] :  otherDriversIncidents.map((incident, index) => {
            return {
                [`otherDriverName${index}`]: {
                    content: (
                        <b>
                            {formatName(incident.driver)}
                        </b>
                    )
                },

                [`otherPassengersContainer${index}`]: {
                    visible: incident.passengers.length > 0,
                    data: incident.passengers
                },

                ...getOtherVehiclePassengersOverrides(incident)
            }
        });

        return Object.assign({}, ...passengers, ...otherDriverIncidents);
    };

    const getDriverOverrides = () => {
        if(mainDriverIncident === undefined) {
            return {}
        }

        return {
            driverName: {
                content: (
                    <b>
                        {formatName(mainDriverIncident.driver)}
                    </b>
                )
            },
            driverAddressLin1: {
                content: formatAddressLine1(mainDriverIncident.driver)
            },
            driverAddressLin2: {
                content: formatAddressLine2(mainDriverIncident.driver)
            },
            driverPhone: {
                content: `${translator(messages.phone)} ${mainDriverIncident.driver ? formatPhoneNumber(mainDriverIncident.driver.contactNumber_ML) : ''}`
            },
            driverLicense: {
                content: translator(messages.license, { license: mainDriverIncident.driver ? mainDriverIncident.driver.licenseNumber_ML : '' })
            },
            yourPassengersContainer: {
                data: mainDriverIncident.passengers
            }
        }
    }

    const getClaimantOverrides = () => {
        if(claimant === undefined) {
            return {}
        }

        return {
            claimantName: {
                content: (
                    <b>
                        {formatName(claimant.contactDTO)}
                    </b>
                )
            },
        }
    }

    const overrideProps = {
        peopleinvolvedContainer: {
            visible: showSection()
        },
        driverColContainer: {
            visible: mainDriverIncident !== undefined && mainDriverIncident.driver !== undefined
        },       
        claimantColContainer: {
            visible: !_.isUndefined(claimant)
        },
        otherDriverContainer: {
            data: otherDriversIncidents
        },
        yourPassengersSection: {
            visible: mainDriverIncident !== undefined && mainDriverIncident.passengers !== undefined && mainDriverIncident.passengers.length > 0
        },

        ...getDriverOverrides(),
        ...getOtherPeopleOverrides(),
        ...getClaimantOverrides()

    };
    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );

};

MLPeopleInvolvedComponent.propTypes = {
    mainDriverIncident: PropTypes.object.isRequired,
    otherDriversIncidents: PropTypes.arrayOf(PropTypes.object).isRequired,
    claimant: PropTypes.object.isRequired
};

export default MLPeopleInvolvedComponent;
